module.exports = __webpack_public_path__ + "img/media-android.381d7d9c.png";